import { RouteRecordRaw } from 'vue-router';
// layout
import BasicLayout from '@/layouts/BasicLayout.vue';
import SignContractLayout from '@/layouts/SignContractLayout.vue';
import RecordBasicInfo from '@/layouts/RecordBasicInfo.vue';
import SelectContractLayout from '@/layouts/SelectContractLayout.vue';

const routes: Array<RouteRecordRaw> = [
  // 重定向根路由
  {
    path: '/',
    redirect: '/pages/home',
  },
  {
    path: '/index.html',
    redirect: '/pages/home',
  },
  {
    path: '/mpauth',
    name: 'mpauth',
    component: () => import('@/views/auxiliary-page/MpAuth.vue'),
  },
  {
    path: '/error',
    name: 'error',
    component: () => import('@/components/blank/Index.vue'),
  },
  {
    path: '/agreement',
    name: 'agreement-page',
    component: () => import('@/views/records/AuthOpinionPage.vue'),
    meta: {
      // title: '服务协议', // TODO:: title走具体接口后，从meta修改
      appRouterViewId: 'baseinfo',
    },
  },
  // 建档入口引导页
  {
    path: '/records',
    redirect: '/records/guide',
    component: BasicLayout,
    children: [
      {
        path: '/records/guide',
        name: 'records-guide',
        component: () => import('@/views/records/Guide.vue'),
        meta: {
          title: '家医助手',
          appRouterViewId: 'guide',
        },
      },
    ],
  },
  // 建档流程页
  {
    path: '/records',
    redirect: '/records/auth',
    component: SignContractLayout,
    meta: {
      step: 1,
    },
    children: [
      // 身份证验证
      {
        path: '/records/authBaseInfo',
        name: 'auth-base-info',
        components: { 'sign-contract': () => import('@/views/records/AuthBaseInfo.vue') },
        meta: {
          title: '家医助手',
          appRouterViewId: 'baseinfo',
        },
      },
      // 身份证验证
      {
        path: '/records/auth',
        name: 'auth-idcard',
        components: { 'sign-contract': () => import('@/views/records/AuthIdcard.vue') },
        meta: {
          title: '家医助手',
        },
      },
      // 健康卡code码验证
      {
        path: '/records/AuthHealthCode',
        name: 'auth-healthcode',
        components: { 'sign-contract': () => import('@/views/records/AuthHealthCode.vue') },
        meta: {
          title: '家医助手',
        },
      },
      // 建档表单：1、2、3
      {
        path: '/records/add',
        redirect: '/records/add/step1',
        components: { 'sign-contract': RecordBasicInfo },
        // meta: {
        //   keepAlive: true,
        // },
        children: [
          {
            path: '/records/add/step1',
            name: 'add-record-step1',
            component: () => import('@/views/records/AddRecordOfBase.vue'),
            meta: {
              title: '家医助手',
              stepNum: 1,
              stepName: '基础信息',
              appRouterViewId: 'sign',
              signRouterViewId: 'record',
            },
          },
        ],
      },
    ],
  },
  // 实名建档流程页
  {
    path: '/manual-records',
    redirect: '/manual-records/auth',
    component: BasicLayout,
    children: [
      // 人工实名验证
      {
        path: '/manual-records/auth',
        name: 'manual-records',
        component: () => import('@/views/manual-records/AuthManual.vue'),
        meta: {
          title: '家医助手',
        },
      },
      // 获取人工审核机构
      {
        path: '/manual-records/VerifyServiceList',
        name: 'manual-service',
        component: () => import('@/views/manual-records/VerifyServiceList.vue'),
        meta: {
          title: '选择机构',
        },
      },
      // 完成页
      {
        path: '/manual-records/CompleteSuccess',
        name: 'manual-complete',
        component: () => import('@/views/manual-records/CompleteSuccess.vue'),
        meta: {
          title: '选择机构',
        },
      },
    ],
  },
  // 建档表单中，选择建档机构
  {
    path: '/records/sign-org',
    name: 'select-sign-org',
    component: () => import('@/views/records/SelectSignOrg.vue'),
    meta: {
      title: '家医助手',
      // keepAlive: true,
      appRouterViewId: 'sign',
      signRouterViewId: 'record',
    },
  },
  // 辅助类页面
  {
    path: '/pages/',
    redirect: '/pages/home',
  },
  {
    path: '/pages',
    redirect: '/pages/home',
    component: BasicLayout,
    children: [
      {
        path: '/pages/home',
        name: 'home',
        component: () => import('@/views/auxiliary-page/Home.vue'),
        meta: {
          title: '家医助手',
        },
      },
      {
        path: '/pages/user-detail',
        name: 'user-detail',
        component: () => import('@/views/auxiliary-page/UserDetail.vue'),
        meta: {
          title: '健康档案',
        },
      },
      {
        path: '/records/detail',
        name: 'record-detail',
        component: () => import('@/views/records/Detail.vue'),
        meta: {
          title: '成员信息',
        },
      },
      {
        path: '/pages/mine',
        name: 'my-fd',
        component: () => import('@/views/auxiliary-page/MyFd.vue'),
        meta: {
          title: '我的家医',
        },
      },
      {
        path: '/pages/myFamily',
        name: 'myFamily',
        component: () => import('@/views/auxiliary-page/MyFamily.vue'),
        meta: {
          title: '家医助手',
        },
      },
      {
        path: '/pages/sign-list',
        name: 'sign-list',
        component: () => import('@/views/auxiliary-page/SignList.vue'),
        meta: {
          title: '签约管理',
        },
        beforeEnter: (to) => {
          if (to.query.type === 'modify') {
            to.meta.title = '变更签约';
            return true;
          }

          return true;
        },
      },
    ],
  },
  // 签约相关
  {
    path: '/contract/',
    redirect: '/contract/doctor',
  },
  {
    path: '/contract/team',
    name: 'contract-team-introduce',
    component: () => import('@/views/contract-doctor/TeamIntroduce.vue'),
    meta: {
      title: '团队介绍',
    },
  },
  {
    path: '/contract/detail',
    name: 'contract-detail',
    component: () => import('@/views/contract-doctor/Detail.vue'),
    meta: {
      title: '签约详情',
    },
  },
  {
    path: '/contract/pkg-detail',
    name: 'contract-pkg-detail',
    component: () => import('@/views/contract-doctor/PkgDetail.vue'),
    meta: {
      title: '服务包详情',
    },
  },
  // 签约引导首页、成功、添加微信
  {
    path: '/contract',
    redirect: '/contract/doctor',
    component: SignContractLayout,
    children: [
      {
        path: '/contract/doctor',
        name: 'contract-index',
        components: { 'sign-contract': () => import('@/views/contract-doctor/ContractDoctor.vue') },
        meta: {
          title: '签约医生',
          step: 2,
          appRouterViewId: 'sign',
        },
      },
      {
        path: '/contract/success',
        name: 'contract-success',
        components: { 'sign-contract': () => import('@/views/contract-doctor/ContractSuccess.vue') },
        meta: {
          title: '提交签约',
          step: 3,
        },
      },
      {
        path: '/contract/add-wx',
        name: 'contract-add-wx',
        components: { 'sign-contract': () => import('@/views/contract-doctor/AddWx.vue') },
        meta: {
          title: '签约',
          step: 5,
        },
      },
    ],
  },
  // 签约选择：机构、团队、服务
  {
    path: '/contract/select',
    component: SelectContractLayout,
    children: [
      {
        path: '/contract/select/service',
        name: 'contract-service',
        components: { 'select-contract': () => import('@/views/contract-doctor/ServiceList.vue') },
        meta: {
          title: '服务机构',
          step: 1,
          appRouterViewId: 'sign',
        },
      },
      {
        path: '/contract/select/doctorteam',
        name: 'contract-doctorteam',
        components: { 'select-contract': () => import('@/views/contract-doctor/DoctorTeam.vue') },
        meta: {
          title: '医生团队',
          step: 2,
          appRouterViewId: 'sign',
        },
      },
      {
        path: '/contract/select/package',
        name: 'contract-package',
        components: { 'select-contract': () => import('@/views/contract-doctor/ServicePackage.vue') },
        meta: {
          title: '服务包',
          step: 3,
          appRouterViewId: 'sign',
        },
      },
    ],
  },
  {
    path: '/follow-up',
    redirect: '/follow-up/plans',
    component: BasicLayout,
    children: [
      {
        path: '/follow-up/plans',
        name: 'follow-plans',
        component: () => import('@/views/follow-up/plans/Index.vue'),
        meta: {
          title: '健康管理计划',
        },
      },
      {
        path: '/follow-up/history',
        name: 'follow-history',
        component: () => import('@/views/follow-up/history/Index.vue'),
        meta: {
          title: '历史计划',
        },
      },
      {
        path: '/follow-up/detail',
        name: 'follow-detail',
        component: () => import('@/views/follow-up/detail/Index.vue'),
        meta: {
          title: '计划详情',
        },
      },
      {
        path: '/follow-up/questionnaire',
        name: 'follow-questionnaire',
        component: () => import('@/views/follow-up/questionnaire/Index.vue'),
        meta: {
          title: '计划详情',
        },
      },
      {
        path: '/follow-up/complete',
        component: () => import('@/views/follow-up/questionnaire/Complete.vue'),
        meta: {
          title: '计划详情',
        },
      },
    ],
  },
  {
    path: '/patient-list',
    redirect: '/patient-list/index',
    component: BasicLayout,
    children: [
      {
        path: '/patient-list/index',
        name: 'patient-home',
        component: () => import('@/views/full-cycle/patient-list/Index.vue'),
        meta: {
          title: '家医助手',
        },
      },
    ],
  },
  // 兜底路由
  {
    path: '/:pathMatch(.*)*',
    redirect: '/pages/home',
  },
];

/**
 * keep-alive队列
 */
export const keepAliveRoutes = [
  'ContractDoctor',
  'SignContractLayout',
  'AuthIdcard',
  'RecordBasicInfo',
  'AddRecordOfBase',
  'AddRecordOfSocial',
  'AddRecordOfContact',
  // 'SelectSignOrg',
  'SelectContractLayout',
  'ServiceList',
  'DoctorTeam',
  'ServicePackage',
  'FollowUpPlansList',
  'FollowUpHistoryList',
  'AuthManual',
  'VerifyServiceList',
  'AuthBaseInfo',
];
/**
 * keep-alive排除队列
 */
export const excludeRoutes = ref<string[]>([]);

/**
 * 添加某组件到keep-alive排除队列
 * @param routeName
 */
export function addRouteToExclude(routeName: string) {
  console.log('xxx-exclude', routeName);
  if (!excludeRoutes.value.includes(routeName)) {
    excludeRoutes.value.push(routeName);
  }
}

/**
 * 恢复某组件为keep-alive
 * @param routeName
 */
export function recoverKeepAlive(routeName: string) {
  console.log('xxx-recover', routeName);
  excludeRoutes.value = excludeRoutes.value.filter((item) => item !== routeName);
}

export default routes;
